module.exports = __webpack_public_path__ + "img/t2-23.16f250d6.svg";